import { Router } from '../../router';

export const App = () => {
  return <Router />;
};
